// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> brookwood-village
// Generated: 2026-11-02T18:11:10.685Z
// Counts: 0 design, 39 content, 21 slot group, 1 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Spacious Choices for Every Life</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Vibrant Setting in South OKC</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>A Premier Downtown Destination</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Brookwood Village in Oklahoma City, OK, everyday living gets an upgrade with features designed for comfort and connection. Unwind in spacious apartments with walk-in closets, a dining room, and select homes featuring private patios or balconies. Around the community, discover places to connect, play, or recharge - from a fitness center and pool to walking trails and a game room. Whether it's furry friends enjoying the pet park, kids at the playground, or you shooting hoops on the basketball court, there's something for everyone at Brookwood Village.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have questions about life at Brookwood Village? Reach out to our leasing team in Oklahoma City, OK - we look forward to helping you discover our community and find your next apartment home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the right fit with our studio, one-, two-, and three-bedroom apartments for rent in Oklahoma City, OK. Each home offers roomy layouts with plenty of space to unwind or work from home, plus spacious closets for easy organization and inviting dining spaces. Select homes offer private patios or balconies for outdoor living, and every apartment is designed for daily comfort.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Studio, 1, 2, and 3 bedroom homes, perfectly located in Oklahoma City, OK</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our photo gallery at Brookwood Village and imagine the life that awaits you in Oklahoma City, OK. See for yourself the welcoming kitchens, roomy living spaces, and well-lit rooms perfect for every part of your day. Explore our social spots and outdoor amenities, designed for relaxation, connection, and fun. Like what you see? Picture yourself here.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Warm living and modern amenities in Oklahoma City, OK.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Make the most of your days in South Oklahoma City at Brookwood Village. With Walmart, favorite local restaurants, and Will Rogers World Airport nearby, errands and adventures are always close at hand. Easy access to I-35 and I-240 connects you with the best of the city, while local parks and peaceful ponds invite you to enjoy nature. Find everything you need for daily life within minutes of your front door, in a community that welcomes you home in every season.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in South Oklahoma City, Brookwood Village puts you near everyday musts and local gems - Walmart, restaurants, and Will Rogers World Airport. Getting around is easy with I-35 and I-240 nearby. Enjoy the outdoors or wander to neighborhood parks, then unwind in your welcoming apartment or take a walk on the ponds and trails just outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking for apartments for rent in Oklahoma City, OK? At Brookwood Village, you'll find comfortable homes and inviting community spaces designed for everyday ease, whether you're relaxing after a busy day or enjoying pet-friendly strolls. Choose from a variety of modern floor plans and enjoy a lifestyle built on comfort and simplicity. Here, convenience is yours - from in-home comforts to community connections.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>See Brookwood Village in Oklahoma City, OK, your way. Choose a private in-person tour, schedule a live guided virtual walk-through, or take advantage of our video tour options. Our leasing team is here to help you discover the space that feels just right. Flexible tour choices make it simple to start your journey to your next home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside Brookwood Village Apartments virtually and envision your life in Oklahoma City, OK. Whether you're considering a cozy studio or a roomy three-bedroom, our virtual tour lets you explore layouts, get a feel for the inviting community, and imagine yourself at home, all from your couch. It's all about giving you a closer look at our comfortable spaces and the welcoming atmosphere that makes Brookwood Village special.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-8794-713f-a12f-9b41d1f4173d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious residential gym with cardio machines, weight equipment, and mirrored wall."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-9bde-7659-9221-7959c40dc4ea.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious apartment community lobby with seating, stairs, and large windows."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-9092-723f-b355-d5a1f903f165.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor community pool with surrounding deck and apartment buildings in the background."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-e361-71d6-a615-44df0385e275.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior living room of an apartment with a gray sofa, coffee table, staircase, and potted plants."
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-78a1-75ed-9cf8-67a46c96fa34.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a dark wood bed frame, mustard throw, beige carpet, and large windows."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-dfbc-7379-b2b2-78d42995ffd7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room in an apartment with a beige sofa, patterned chairs, a brown rug, and a window with purple curtains."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-f4ca-765d-94cd-0d08145517e5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bench beside the tree-lined pond at Brookwood Village under a blue sky."
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-ec7f-7203-824f-a3928a183078.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Narrow galley kitchen with white cabinets, double sink, fridge and stove."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-78a1-75ed-9cf8-67a46c96fa34.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a dark wood bed frame, mustard throw, beige carpet, and large windows."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167180/019d021d-e361-71d6-a615-44df0385e275.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior living room of an apartment with a gray sofa, coffee table, staircase, and potted plants."
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": [
      "ec_50897b90966968debb603999"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
